import MResponseFlowSummary from './index.vue';

MResponseFlowSummary.install = app => {
  app.component(MResponseFlowSummary.name, MResponseFlowSummary);
};

export default MResponseFlowSummary;
